module.exports = __webpack_public_path__ + "media/assets/images/flags/mv-a9ceb9ee06f26f29fa2d39270504169c.svg";